// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"911adb09","455":"abf5f3f1","488":"0dc2c96f","977":"2ff694a4"}[chunkId] + ".chunk.js";
};